import { SVGProps } from 'react'

export const ChevronLeft = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0267 4.08035L9.08029 12.0268L17.0267 19.9732L15.9732 21.0268L6.97317 12.0268L15.9732 3.02679L17.0267 4.08035Z"
      fill="currentColor"
    />
  </svg>
)
